import { StoreonDispatch } from 'storeon';
import { FETCH_SPONSORED_BRANDS, SPONSORED_BRANDS_RESET, SponsoredBrandsEvent } from 'actions';
import { useCallback } from 'react';
import { SponsoredBrandRequest } from 'types/sponsored-brands';

export const useGetSponsoredBrands = (dispatch: StoreonDispatch<SponsoredBrandsEvent>) => {
  const getSponsoredBrands = useCallback(
    (props: SponsoredBrandRequest) => dispatch(FETCH_SPONSORED_BRANDS.init, props),
    [dispatch],
  );

  const resetSponsoredBrands = useCallback(() => dispatch(SPONSORED_BRANDS_RESET), [dispatch]);

  return { getSponsoredBrands, resetSponsoredBrands };
};
